import React from 'react';
import { Switch, Route, useParams } from 'react-router-dom';
import _sortBy from 'lodash/sortBy';

import Page from '@common/components/app-layout/page';
import PageContent from '@common/components/app-layout/page-content';
import InlineLoadingIndicator from '@common/components/loading-indicator/inline-loading-indicator';
import SuspendRender from '@common/components/suspend-render/suspend-render';

import UtilityHeader from '@aware/common/utility-header';
import V2SettingsIframe from '@aware/common/v2-settings-iframe';
import ReportGroup from '@common/components/reports/report-group';
import Report from '@common/components/reports/report';

import { useLoadReportData, useAddNavigationCallback } from './hooks';
import { addWidthToCustomSelectElements } from './helpers';

const V2ReportsPage = ({ tabId, baseRoute }) => {
  useAddNavigationCallback();
  const { isLoading, reportsByGroup, reportsMap } = useLoadReportData(tabId);
  const { reportId } = useParams();
  const reportsByGroupArr = Object.values(reportsByGroup);

  return (
    <SuspendRender
      isLoading={isLoading}
      loadingComponent={<InlineLoadingIndicator backgroundColor="transparent" />}
    >
      <Switch>
        <Route path={`${baseRoute}/:reportId`}>
          <V2SettingsIframe
            iframeSrc={reportsMap[reportId]?.reportUrl}
            title={reportsMap[reportId]?.title}
            onLoadCallback={addWidthToCustomSelectElements}
          />
        </Route>
        <Route path="/">
          <UtilityHeader title="Reports" />
          <Page>
            <PageContent pagePadding>
              {_sortBy(reportsByGroupArr, 'order').map(({ title, reports }) => {
                return (
                  <ReportGroup
                    key={title}
                    title={title}
                    totalReportGroups={reportsByGroupArr.length}
                  >
                    {Object.values(reports).map(
                      ({ id, title: reportTitle, imageUrl, pageUrl }) => {
                        return (
                          <Report
                            key={id}
                            imageUrl={imageUrl}
                            pageUrl={pageUrl}
                            title={reportTitle}
                          />
                        );
                      }
                    )}
                  </ReportGroup>
                );
              })}
            </PageContent>
          </Page>
        </Route>
      </Switch>
    </SuspendRender>
  );
};

export default V2ReportsPage;
